export default "__VITE_ASSET__DI5J9Itg__"